export default __webpack_public_path__ + "static/media/add_icon.2ced1ca4.svg";